import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { useRemoveDetail } from '@cibo/landmanager'
import { CircularProgress, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { useCallback } from 'react'
import { TraitCellContainer } from './TraitCells/TraitCellContainer'
import { TRAIT_DISPLAY_MAP } from './traitDisplayMap'

interface TaskEditorTableCellProps extends GridRenderCellParams {
  row: { traitId: string; [key: string]: any }
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  selectedField?: FieldModel
  onSaveSuccess?: () => void
  onDeleteSuccess?: () => void
  isLoading?: boolean
}

export const TaskEditorTableCell = ({
  row: { traitId },
  value,
  field: year,
  task,
  selectedField,
  onSaveSuccess,
  onDeleteSuccess,
  isLoading,
}: TaskEditorTableCellProps) => {
  const Display = TRAIT_DISPLAY_MAP[traitId]
  const removeDetail = useRemoveDetail()

  const handleDelete = useCallback(() => {
    if (!value || !selectedField?.resourceId) return
    removeDetail.mutateAsync({ resourceId: selectedField.resourceId, traitId, year: +year }).then(() => {
      onDeleteSuccess?.()
    })
  }, [value, selectedField?.resourceId, traitId, year, removeDetail, onDeleteSuccess])

  if (!Display) {
    return (
      <Stack>
        <Typography>{JSON.stringify(value)}</Typography>
      </Stack>
    )
  }

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <TraitCellContainer
        value={value}
        task={task}
        selectedField={selectedField}
        year={+year}
        traitId={traitId}
        onSaveSuccess={onSaveSuccess}
        onDelete={handleDelete}
      >
        <Display value={value} />
      </TraitCellContainer>
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'action.hover',
          }}
        >
          <CircularProgress size={16} />
        </Box>
      )}
    </Box>
  )
}
